import { Module } from 'vuex'

interface State {
    mousePosition: { x: number; y: number }
}

const store: Module<State, unknown> = {
    namespaced: true,
    state() {
        return {
            mousePosition: { x: 0, y: 0 },
        }
    },
    mutations: {
        setMousePosition(state: State, { x, y }: { x: number; y: number }) {
            state.mousePosition.x = x
            state.mousePosition.y = y
        },
    },
}

export default store
